import React from "react";
import Layout from "../../layout/Layout";
import CommutingMediumTemplate from "../../templates/commuting-medium-template/Main";
import { useSeoData } from "../../templates/seo/Main";

const BusPage = ({ pageContext }) => {
  const {
    breadcrumb: { crumbs },
  } = pageContext;
  return (
    <Layout crumbs={crumbs} crumbLabel={"Bus"}>
      <CommutingMediumTemplate keyword={"Bus"} />
    </Layout>
  );
};

export default BusPage;

// Seo meta details
export const Head = () => {
  const { meta_title, meta_description, meta_keyword } = useSeoData("bus");

  return (
    <>
      <title>{meta_title}</title>
      <meta
        name="description"
        content={meta_description?.data?.meta_description}
      />
      <meta name="keywords" content={meta_keyword?.data?.meta_keyword} />
    </>
  );
};
